import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';

import { get, map } from 'lodash-es';

import { fieldShape, selectionShape } from './index.shape';
import { getFormatOptionLabelDefault, getOptions, getValue, styleCustom, themeCustom } from './index.utils';

import './index.scss';

/**
 * select component
 * @param props
 * @returns {XML}
 * @constructor
 */
const SelectCommon = props => {
  const {
    field: { name, value },
    selection,
    isMulti,
    placeholder,
    disabled,
    formatOptionLabel,
    width,
    existError,
    showError,
    minWidthMenu,
    height,
    eventEmitter,
    ...other
  } = props;
  const [valueLocal, setValueLocal] = useState(getValue({ value, isMulti, options: getOptions({ selection }) }));

  const handleChangeLocal = selectedOption => {
    const fieldValue = isMulti ? map(selectedOption, option => get(option, 'value')) : get(selectedOption, 'value');
    //
    setValueLocal(getValue({ value: fieldValue, isMulti, options: getOptions({ selection }) }));
    eventEmitter(fieldValue);
  };

  // TODO observable value
  useEffect(() => {
    setValueLocal(getValue({ value, isMulti, options: getOptions({ selection }) }));
  }, [value]);

  return (
    <Select
      {...other} // eslint-disable-line react/jsx-props-no-spreading
      className="coog-select"
      value={valueLocal}
      name={name}
      styles={styleCustom({ width, height, existError, showError, minWidthMenu })}
      theme={themeCustom({ existError, showError })}
      placeholder={placeholder}
      onChange={handleChangeLocal}
      formatOptionLabel={formatOptionLabel}
      options={getOptions({ selection })}
      isDisabled={disabled}
      isLoading={false}
      isMulti={isMulti}
    />
  );
};

SelectCommon.propTypes = {
  field: PropTypes.shape(fieldShape),
  selection: PropTypes.arrayOf(selectionShape).isRequired,
  isMulti: PropTypes.bool,
  formatOptionLabel: PropTypes.func,
  placeholder: PropTypes.string,
  width: PropTypes.string,
  minWidthMenu: PropTypes.string,
  height: PropTypes.string,
  disabled: PropTypes.bool,
  existError: PropTypes.bool,
  showError: PropTypes.bool,
  eventEmitter: PropTypes.func.isRequired,
};

SelectCommon.defaultProps = {
  field: {
    value: undefined,
  },
  formatOptionLabel: getFormatOptionLabelDefault,
  disabled: false,
  width: undefined,
  minWidthMenu: '400px',
  height: undefined,
  existError: false,
  showError: false,
  isMulti: false,
  placeholder: '',
};

export default SelectCommon;
